/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { analiticasControllerAnularCitasPendientes } from '../fn/paciente-analiticas/analiticas-controller-anular-citas-pendientes';
import { AnaliticasControllerAnularCitasPendientes$Params } from '../fn/paciente-analiticas/analiticas-controller-anular-citas-pendientes';
import { analiticasControllerObtenerAnalitica } from '../fn/paciente-analiticas/analiticas-controller-obtener-analitica';
import { AnaliticasControllerObtenerAnalitica$Params } from '../fn/paciente-analiticas/analiticas-controller-obtener-analitica';
import { analiticasControllerObtenerAnaliticas } from '../fn/paciente-analiticas/analiticas-controller-obtener-analiticas';
import { AnaliticasControllerObtenerAnaliticas$Params } from '../fn/paciente-analiticas/analiticas-controller-obtener-analiticas';
import { analiticasControllerObtenerEvolucionParametro } from '../fn/paciente-analiticas/analiticas-controller-obtener-evolucion-parametro';
import { AnaliticasControllerObtenerEvolucionParametro$Params } from '../fn/paciente-analiticas/analiticas-controller-obtener-evolucion-parametro';
import { analiticasControllerObtenerFormularioCancelacion } from '../fn/paciente-analiticas/analiticas-controller-obtener-formulario-cancelacion';
import { AnaliticasControllerObtenerFormularioCancelacion$Params } from '../fn/paciente-analiticas/analiticas-controller-obtener-formulario-cancelacion';
import { AnaliticasModelDto } from '../models/analiticas-model-dto';
import { EncuestaCancelacionDto } from '../models/encuesta-cancelacion-dto';
import { EvolucionValorClaveDto } from '../models/evolucion-valor-clave-dto';
import { ObtenerAnaliticaModelDto } from '../models/obtener-analitica-model-dto';

@Injectable({ providedIn: 'root' })
export class PacienteAnaliticasService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `analiticasControllerObtenerAnaliticas()` */
  static readonly AnaliticasControllerObtenerAnaliticasPath = '/api/paciente-analiticas/obtener-analiticas';

  /**
   * Obtener analíticas.
   *
   * Obtiene las analíticas de un programa específico.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `analiticasControllerObtenerAnaliticas()` instead.
   *
   * This method doesn't expect any request body.
   */
  analiticasControllerObtenerAnaliticas$Response(params?: AnaliticasControllerObtenerAnaliticas$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AnaliticasModelDto>>> {
    return analiticasControllerObtenerAnaliticas(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener analíticas.
   *
   * Obtiene las analíticas de un programa específico.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `analiticasControllerObtenerAnaliticas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  analiticasControllerObtenerAnaliticas(params?: AnaliticasControllerObtenerAnaliticas$Params, context?: HttpContext): Observable<Array<AnaliticasModelDto>> {
    return this.analiticasControllerObtenerAnaliticas$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AnaliticasModelDto>>): Array<AnaliticasModelDto> => r.body)
    );
  }

  /** Path part for operation `analiticasControllerObtenerAnalitica()` */
  static readonly AnaliticasControllerObtenerAnaliticaPath = '/api/paciente-analiticas/obtener-analitica/{uuidAnalitica}';

  /**
   * Obtener analítica.
   *
   * Obtiene una analítica específica por su UUID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `analiticasControllerObtenerAnalitica()` instead.
   *
   * This method doesn't expect any request body.
   */
  analiticasControllerObtenerAnalitica$Response(params: AnaliticasControllerObtenerAnalitica$Params, context?: HttpContext): Observable<StrictHttpResponse<ObtenerAnaliticaModelDto>> {
    return analiticasControllerObtenerAnalitica(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener analítica.
   *
   * Obtiene una analítica específica por su UUID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `analiticasControllerObtenerAnalitica$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  analiticasControllerObtenerAnalitica(params: AnaliticasControllerObtenerAnalitica$Params, context?: HttpContext): Observable<ObtenerAnaliticaModelDto> {
    return this.analiticasControllerObtenerAnalitica$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObtenerAnaliticaModelDto>): ObtenerAnaliticaModelDto => r.body)
    );
  }

  /** Path part for operation `analiticasControllerObtenerEvolucionParametro()` */
  static readonly AnaliticasControllerObtenerEvolucionParametroPath = '/api/paciente-analiticas/obtener-evoluticon-valor-clave/{uuidParametro}';

  /**
   * Obtener evolución de un parámetro.
   *
   * Obtiene la evolución de un parámetro específico por su UUID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `analiticasControllerObtenerEvolucionParametro()` instead.
   *
   * This method doesn't expect any request body.
   */
  analiticasControllerObtenerEvolucionParametro$Response(params: AnaliticasControllerObtenerEvolucionParametro$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EvolucionValorClaveDto>>> {
    return analiticasControllerObtenerEvolucionParametro(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener evolución de un parámetro.
   *
   * Obtiene la evolución de un parámetro específico por su UUID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `analiticasControllerObtenerEvolucionParametro$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  analiticasControllerObtenerEvolucionParametro(params: AnaliticasControllerObtenerEvolucionParametro$Params, context?: HttpContext): Observable<Array<EvolucionValorClaveDto>> {
    return this.analiticasControllerObtenerEvolucionParametro$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EvolucionValorClaveDto>>): Array<EvolucionValorClaveDto> => r.body)
    );
  }

  /** Path part for operation `analiticasControllerObtenerFormularioCancelacion()` */
  static readonly AnaliticasControllerObtenerFormularioCancelacionPath = '/api/paciente-analiticas/formulario-cancelacion';

  /**
   * Obtener formulario de cancelación.
   *
   * Obtiene el formulario de cancelación de un programa específico.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `analiticasControllerObtenerFormularioCancelacion()` instead.
   *
   * This method doesn't expect any request body.
   */
  analiticasControllerObtenerFormularioCancelacion$Response(params?: AnaliticasControllerObtenerFormularioCancelacion$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EncuestaCancelacionDto>>> {
    return analiticasControllerObtenerFormularioCancelacion(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener formulario de cancelación.
   *
   * Obtiene el formulario de cancelación de un programa específico.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `analiticasControllerObtenerFormularioCancelacion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  analiticasControllerObtenerFormularioCancelacion(params?: AnaliticasControllerObtenerFormularioCancelacion$Params, context?: HttpContext): Observable<Array<EncuestaCancelacionDto>> {
    return this.analiticasControllerObtenerFormularioCancelacion$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EncuestaCancelacionDto>>): Array<EncuestaCancelacionDto> => r.body)
    );
  }

  /** Path part for operation `analiticasControllerAnularCitasPendientes()` */
  static readonly AnaliticasControllerAnularCitasPendientesPath = '/api/paciente-analiticas/enviar-formulario-cancelacion';

  /**
   * Anular citas pendientes en caso de que se responda correctamente el formulario de cancelación.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `analiticasControllerAnularCitasPendientes()` instead.
   *
   * This method doesn't expect any request body.
   */
  analiticasControllerAnularCitasPendientes$Response(params?: AnaliticasControllerAnularCitasPendientes$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return analiticasControllerAnularCitasPendientes(this.http, this.rootUrl, params, context);
  }

  /**
   * Anular citas pendientes en caso de que se responda correctamente el formulario de cancelación.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `analiticasControllerAnularCitasPendientes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  analiticasControllerAnularCitasPendientes(params?: AnaliticasControllerAnularCitasPendientes$Params, context?: HttpContext): Observable<void> {
    return this.analiticasControllerAnularCitasPendientes$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
